
import React, { useEffect, useState, useContext,useRef } from 'react';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import {timesheetreportService} from '../../services/timesheetreportsService';
import {timesheetService} from '../../services/timesheetService';
import {timesheetuserService} from '../../services/timesheetUserservice';
import {formatterhelper} from '../../helpers/dateformatter';
import { Paginator } from 'primereact/paginator';
import {loader} from '../../compnents/loadermd';
import { Dialog } from 'primereact/dialog';
import { FaBeer,FaCheck,FaEdit,FaRecycle,FaSearch,FaCross, FaTrash } from "react-icons/fa";
import Smallloader from '../../compnents/loader';
import {adminService} from '../../services/adminService';
import { Toast } from 'primereact/toast';
import { Message } from 'primereact/message';
import { ToggleButton } from 'primereact/togglebutton';
import { func } from 'prop-types';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import {Mandate} from '../../compnents/formcomp';

const Permissions = ({tabname}) => {
    const toast = useRef(null);
    const [formData, setFormData] = useState({
        selecteduser: '',
        selectedelement:'',
      });
    
    const [formDatar,setFormDatar] = useState({
        selecteduserr:'',
        selectroler:'' 
    });  
    const [datacomp,setDatacomp] = useState([]); 
    const [datacomptemp,setDatacomptemp] = useState([]); 
    const [projcomp,setProjcomp] = useState([]); 
    const [budgethrs,setbudgethrs] = useState([]); 
    const [clientcomp,setClientcomp] = useState([]); 
    const [usercomp,setUsercomp] = useState([]); 
    const [rdsdatacomp,setrdsDatacomp] = useState([]); 
    const [dataavail,setDatastate] = useState(false); 
    const [cleintscomp,setClientscomp] = useState([]); 
    const [subclientscomp,setsubClientscomp] = useState([]); 
    const [subtaskscomp,settaskscomp] = useState([]);
    const [subclientLoader,setSubclientloader] = useState(<></>);
    const [empcomp,setempcomp] = useState([]); 
    const [totalpages,setPages] = useState(0);
    const [filterobj,setfilterobj] = useState({});
    const userdata = localStorage.getItem('user') != '' ? JSON.parse(localStorage.getItem('user')) : {};
    const userroledata = localStorage.getItem('role') != '' ? JSON.parse(localStorage.getItem('role')) : {};
    const [isloaded,setloading] = useState(true);
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(15);
    const [addtimesheettoggle,settoggle] = useState(false); 
    const [editobj,seteditobj] = useState({'client':'','budget':''});
    const [errors, setErrors] = useState({});
    const [errorsr, setErrorsr] = useState({});
    const [editerrors, seteditErrors] = useState({});
    const [newobjdata, setNewobj] = useState({});
    const [isclientmerge, setclientmerge] = useState(false);
    const [permissiondat, setpermission] = useState([]);
    const [permissiondattemp, setpermissiontemp] = useState([]);
    const allPermissionsRef = useRef([]);
    const [selectedpermission, setselectedpermission] = useState('');
    const [setrole, setselectedrole] = useState('');
    
     
    useEffect(()=>{
        getallclient();
        getpermission();
        getemplist();
        // getclientwisebudget();
        setselectedpermission(userroledata.rolename);
    },[]);


    function getadminrole(userid){
       adminService.getadminrole({userid:userid}).then((response)=>{
          if(response.status == 200){
            
            if(response.data.data[0] != undefined){
                if(response && response != undefined){
                    // setselectedrole(response.data.data[0].rolename); 
                    setFormDatar((prevData) => ({...prevData,selectroler:response.data.data[0].rolename}));
                }else{
                    setFormDatar((prevData) => ({...prevData,selectroler:''}));
                }  
            }
          }else{
            console.log(""); 
            setFormDatar((prevData) => ({...prevData,selectroler:''})); 
          }  
       }).catch((error)=>{
           console.log("error"); 
           setFormDatar((prevData) => ({...prevData,selectroler:''}));  
       });  
    }


    const getpermission = () =>{
        adminService.getpermission().then((response)=>{
           if(response.status == 200){
               let elem = response.data.data[0].elements;
               let elobj = JSON.parse(elem);
               allPermissionsRef.current = elobj;
               const resetObj = elobj.map(p => ({ ...p, value: 'no' }));
               setpermission(resetObj);
               console.log(elobj);
           }else{
               setpermission([]);
           }
        }).catch((error)=>{
           console.log(error);
           setpermission([]);
        });
    }

    const updatePermission = (index) => {
        setpermission((prevData) =>
          prevData.map((item, idx) =>
            idx === index ? { ...item, value: item.value === 'no' ? 'yes' : 'no' } : item
          )
        );
      };

    const toggleAllPermissions = (checked) => {
        setpermission((prevData) =>
            prevData.map((item) => ({ ...item, value: checked ? 'yes' : 'no' }))
        );
    };

    function diplaypermission(){
        let emparr = [];
        permissiondat.forEach((values,index)=>{
            const isChecked = values.value === 'yes';
            emparr.push((
                <div
                    key={index}
                    onClick={() => updatePermission(index)}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        padding: '7px 12px',
                        borderRadius: '6px',
                        border: isChecked ? '1.5px solid #6366f1' : '1.5px solid #e5e7eb',
                        background: isChecked ? '#eef2ff' : '#f9fafb',
                        margin: '4px',
                        cursor: 'pointer',
                        minWidth: '170px',
                        userSelect: 'none',
                    }}
                >
                    <input
                        type='checkbox'
                        checked={isChecked}
                        onChange={() => updatePermission(index)}
                        onClick={(e) => e.stopPropagation()}
                        style={{ accentColor:'#6366f1', width:'14px', height:'14px', cursor:'pointer', flexShrink:0 }}
                    />
                    <span style={{
                        fontSize: '12px',
                        fontWeight: isChecked ? 600 : 500,
                        color: isChecked ? '#4f46e5' : '#6b7280',
                        lineHeight: '1.3',
                    }}>
                        {values.label}
                    </span>
                </div>
            ));
        });

        return (<div style={{ display:'flex', flexWrap:'wrap', padding:'10px 0 4px' }}>{emparr}</div>);
    }

    const handleChange = (e) => {
        try{
            const { name, value } = e.target;
            setFormData((prevData) => ({
              ...prevData,
              [name]: value,
            }));

            if(name == 'selecteduser'){
                getuserspermission(value); 
            }
    
        }catch(e){
            console.log(e);
        }
        
    };

    const handleChanger = (e) =>{
        try{
            const { name, value } = e.target;
            setFormDatar((prevData) => ({
              ...prevData,
              [name]: value,
            }));


            if(name == 'selecteduserr'){
                getadminrole(value);
            }
    
        }catch(e){
            console.log(e);
        }  
    }

    const validateFormr = () => {
        let valid = true;
        const newErrors = {};
        if (formDatar.selecteduserr == '' || formDatar.selecteduserr == undefined) {
          valid = false;
          newErrors.selecteduserr = 'Field is required';
        }

        if (formDatar.selectroler == '' || formDatar.selectroler == undefined) {
            valid = false;
            newErrors.selectroler = 'Field is required';
        }
        setErrorsr(newErrors);
       return valid; 
    }

    const handleSubmitr = (e) => {
        e.preventDefault();
        if(!validateFormr()){
             return;
        }
        console.log("form data r");
        console.log(formDatar);
        adminService.updaterole({formdata:formDatar}).then((response)=>{
            if(response.status == 200){
                toast.current.show({severity:'success', summary: "Role", detail:`Updated`, life: 3000});            
            }else{
                toast.current.show({severity:'error', summary: "Role ", detail:`Not Updated`, life: 3000});          
            }
        }).catch((error)=>{
            console.log(error); 
            toast.current.show({severity:'error', summary: "Role ", detail:`Error`, life: 3000});
        });
    }


    const validateForm = () => {
        let valid = true;
        const newErrors = {};
        if (formData.selectedclient == '') {
            newErrors.selectedclient = 'Client is required';  
            valid = false;
        }

        if (formData.monthmdl == '') {
            newErrors.monthmdl = 'Month is required';
            valid = false;
        }

        if (formData.budgetmdl == '') {
            newErrors.budgetmdl = 'Budget is required'; 
            valid = false;
        }
        setErrors(newErrors);
       return valid; 
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if(!validateForm()){
            return;
        }
        
        let obj = {'user':formData.selecteduser,'permissiondata':permissiondat};
        adminService.updatepermission({formdata:obj}).then((response)=>{
           if(response.status == 200){
               console.log(response);    
               toast.current.show({severity:'success', summary: "Permission", detail:`Updated`, life: 3000});          
               getuserspermission(formData.selecteduser);
            }else{
               toast.current.show({severity:'error', summary: "Permission", detail:`Not Updated`, life: 3000});          
           }
        }).catch((error)=>{
            // console.log(error);
            toast.current.show({severity:'error', summary: "Permission", detail:`Error`, life: 3000});          
        });
        
        // permissions(); 
    };

    function getallclient(){
        let emparr = [];
        adminService.getallclient().then((response)=>{
           response.data.data.forEach((value,index)=>{
            if(value.client != ''){
                emparr.push(<option value={value.client}>{value.client}</option>);
            }
           
           });
           setClientcomp(emparr);
        }).catch((error)=>{
           console.log(error);  
        });   
    }

    function getemplist(){
        let member = userdata.id;
        let managerid = member;
        let emparr = [];
        timesheetreportService.getemployeelist({managerid:managerid}).then((response)=>{
           console.log(response);
           response.data.data.forEach((value,index) =>{
              if(value.id != 1){
                  emparr.push((<option value={value.id}>{value.name}</option>));   
              }
           });
           setempcomp(emparr);
        }).catch((error)=>{

        });  
    }

    function getuserspermission(userid){
        adminService.getuserspermission(userid).then((response)=>{
           console.log(response.data.data[0].element);
           if(response.status == 200){
                let parseobj = JSON.parse(response.data.data[0].element);
                setpermissiontemp(parseobj);
                const userPermMap = {};
                parseobj.forEach(p => { userPermMap[p.label] = p.value; });
                const merged = allPermissionsRef.current.map(p => ({
                    ...p,
                    value: userPermMap[p.label] !== undefined ? userPermMap[p.label] : 'no'
                }));
                setpermission(merged);
           }else{
                setpermissiontemp([]);
                const reset = allPermissionsRef.current.map(p => ({ ...p, value: 'no' }));
                setpermission(reset);
           }
        }).catch((error)=>{
            console.log(error);
            setpermissiontemp([]);
            const reset = allPermissionsRef.current.map(p => ({ ...p, value: 'no' }));
            setpermission(reset);
        });
    }

    function diplayuserspermission(){
        let emparr = [];
        permissiondattemp.forEach((values,index)=>{
            const isChecked = values.value === 'yes';
            emparr.push((
                <div
                    key={index}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        padding: '7px 12px',
                        borderRadius: '6px',
                        border: isChecked ? '1.5px solid #6366f1' : '1.5px solid #e5e7eb',
                        background: isChecked ? '#eef2ff' : '#f9fafb',
                        margin: '4px',
                        minWidth: '170px',
                        userSelect: 'none',
                    }}
                >
                    <input
                        type='checkbox'
                        checked={isChecked}
                        readOnly
                        style={{ accentColor:'#6366f1', width:'14px', height:'14px', flexShrink:0 }}
                    />
                    <span style={{
                        fontSize: '12px',
                        fontWeight: isChecked ? 600 : 500,
                        color: isChecked ? '#4f46e5' : '#6b7280',
                        lineHeight: '1.3',
                    }}>
                        {values.label}
                    </span>
                </div>
            ));
        });

        return (<div style={{ display:'flex', flexWrap:'wrap', padding:'10px 0 4px', pointerEvents:'none', opacity:0.6 }}>{emparr}</div>);
    }

 return (
        <>
            <Toast ref={toast} />
            <ConfirmDialog /> 
            <div className="invisible-divider-sm"></div>
            <h6 className='card-style-padding-two'>{tabname}</h6>
            <div className='card card-custom-style card-style-padding' style={{borderbottom: '1px solid #f1f1f1 !important'}}>
               
              <div className='row'>
                   <div className='card card-custom-style card-style-padding card-shadow'>
                        <h6 className='card-style-padding-two'><span className="error">*</span> Roles</h6>
                        <form onSubmit={(e) => handleSubmitr(e)}>
                        <div className='row'>
                        <div className="col-md-4"> 
                        <label className='pull-left'><Mandate/> Select User</label>
                                <br/>
                            <select className='custom-dropdown-style' name="selecteduserr" class="form-control" onChange={(e) => handleChanger(e)}>
                                <option value="">Select User</option>
                                {empcomp}
                            </select>  
                            {errorsr.selecteduserr && <span className='error'>{errorsr.selecteduserr}</span>}
                            </div>
                            <div className="col-md-4">
                            
                                <label className='pull-left'><Mandate/> Select Role</label>
                                <br/>
                                <div className='container-box'>
                                <select className='custom-dropdown-style' value={formDatar.selectroler} name="selectroler" class="form-control" onChange={(e) => handleChanger(e)}>
                                    <option value="">Select Role</option>
                                    <option value="superadmin">Super admin</option>
                                    <option value="admin">admin</option>
                                    <option value="normal">normal</option>
                                </select>
                                </div>
                                {errorsr.selectroler && <span className='error'>{errorsr.selectroler}</span>}
                                {/* {errors.selectedclient && <span className='error'>{errors.selectedclient}</span>} */}
                            </div>
                            <div className='col-md-3'> 
                            <br/>
                            <button type='submit' className='btn btn-success'>Save Role</button>
                            </div>
                            </div>  
                            </form>
                        </div> 
                 
                 <br/><br/>
             </div>

             <div className='row' style={{marginTop:'24px'}}>
               <div className='card card-custom-style card-style-padding card-shadow'> 
                  <div className='col-md-12'>
                    <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between' }}>
                        <h6 className='card-style-padding-two' style={{ margin:0 }}><span className="error">*</span> Permissions</h6>
                        <div style={{ display:'flex', alignItems:'center', gap:'8px', paddingRight:'8px' }}>
                            <label style={{ margin:0, fontWeight:600, fontSize:'13px', color:'#374151', cursor:'pointer' }} htmlFor="allPermissionsCheck">All Permissions</label>
                            <input
                                id="allPermissionsCheck"
                                type="checkbox"
                                style={{ width:'16px', height:'16px', cursor:'pointer', accentColor:'#6366f1' }}
                                checked={permissiondat.length > 0 && permissiondat.every(p => p.value === 'yes')}
                                onChange={(e) => toggleAllPermissions(e.target.checked)}
                            />
                        </div>
                    </div>
                    {diplaypermission()}
                   </div> 
            
                  <form onSubmit={handleSubmit}>
                        <div className='row'>
                        <div className='col-md-12'>
                        <div className='row'>
                        <div className="col-md-4">
                        <br/>
                                <label className='pull-left'><Mandate/> Users</label>
                                <br/>
                                <div className='container-box'>
                                <select className='custom-dropdown-style' name="selecteduser" class="form-control" onChange={(e) => handleChange(e)}>
                                <option value="">Select User</option>
                                {empcomp}
                                </select>
                                <button onSubmit={()=>handleSubmit()} className='btn btn-success'>Save</button>
                                </div>
                                {/* {errors.selectedclient && <span className='error'>{errors.selectedclient}</span>} */}
                            </div>
                        </div>
                    </div>
                    
                        </div>
                </form>
                   <div className='col-md-12'>
                       <br/><br/>
                       <h6 className='card-style-padding-two' style={{ margin:0 }}><span className="error">*</span> Applied Permissions</h6>
                       {diplayuserspermission()}
                    </div>
                </div>
                </div>
            </div>

               
            <div className="invisible-divider-sm"></div>
            <div className='card card-custom-style card-style-padding'>
              <div className='row'>
                    <div className='col-md-6'></div>
                    <div className='pagination col-md-6'>
                        {/* <PaginationExample items={totalpages} currentPaged={currentPage} lastpage={last_page} perpage={per_page} getuserfun={getUsers}/> */}
                    </div>
                </div>
               
               
                <div className='row'>
                   
                   
                </div>
                <br/> 
            </div>

            <div className="invisible-divider-sm"></div>
            {/* <div className="row">
                <h1>table</h1>
            </div> */}
        </>
    );
}

export default Permissions;
